import { router, Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function CarsLayout() {
  const { theme } = useStyles();

  return (
    <Stack>
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="index"
          options={{
            headerTitle: 'My Cars',
            headerLeft: () => null,
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]"
          options={({ route }) => ({
            headerTitle: '',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }
                  router.navigate('/partner/cars');
                }}
              />
            ),
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}

      {isDesktop() ? (
        <Stack.Screen name="bulk-list" options={{ headerShown: false }} />
      ) : (
        <Stack.Screen
          name="bulk-list"
          options={{
            title: '',
            headerTitle: '',
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
            headerLeft: () => <BackButton />,
          }}
        />
      )}

      {isDesktop() ? (
        <Stack.Screen name="setup/index" options={{ headerShown: false }} />
      ) : (
        <Stack.Screen
          name="setup/index"
          options={{
            title: '',
            headerTitle: '',
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
            headerLeft: () => <BackButton />,
          }}
        />
      )}
    </Stack>
  );
}
